import React from 'react';
import './KechaungHeader.scss';

export const KechuangHeader = () => {
  return (
    <div className="environment-header">
      <video src="https://s3plus.sankuai.com/greentech/static_resource/videos/greenBanner.mp4?AWSAccessKeyId=drgcsp9xg5nnts270000000000314609&Expires=2778292019&Signature=tJwb6wkRS%2B274qU1f1Zq3rPUpsY%3D" muted autoPlay loop className="video-class" />
      <div className="header-content">
        <span className="title" style={{ marginLeft: '-0.6em' }}>
          “科创中国”美团青山环保科技创新示范项目
        </span>
        <div className="content" style={{ marginTop: 10 }}>
          聚焦绿色创新包装、绿色回收再生、绿色供应链体系三大领域，面向中国境内依法注册的法人主体公开征集具有创新性、环保性、示范性的项目。
        </div>
      </div>
    </div>
  );
};
